import { useCallback } from "react";

import { useEvmBackend } from "../context";

/**
 * Raw JSON-RPC request to the backend.
 * Replaces devenv's useAnvilRpc (fetch-based) and webenv's direct client call.
 */
export function useRpcRequest() {
  const { rpcRequest } = useEvmBackend();

  const request = useCallback(
    async (method: string, params: unknown[] = []) => {
      return rpcRequest(method, params);
    },
    [rpcRequest],
  );

  return { request };
}
